import { useContext, useEffect, useState } from 'react';

import Loading from '../Components/Loading/Loading';
import { Context } from '../Context/Context';
import { useApi } from '../Hooks/Api';
import { useToast } from '../Hooks/Toast';
import AgeRoutes from '../Modules/Age/Routes/Routes';
import AgentRoutes from '../Modules/Agent/Routes/Routes';
import CompetitionRoutes from '../Modules/Competition/Routes/Routes';
import CompetitionRegisterRoutes from '../Modules/CompetitionRegister/Routes/Routes';
import DashboardRoutes from '../Modules/Dashboard/Routes/Routes';
import ErrorRoutes from '../Modules/Error/Routes/Routes';
import GymRoutes from '../Modules/Gym/Routes/Routes';
import IDCardRoutes from '../Modules/IDCard/Routes/Routes';
import LevelRoutes from '../Modules/Level/Routes/Routes';
import LogRoutes from '../Modules/Log/Routes/Routes';
import RankRoutes from '../Modules/Rank/Routes/Routes';
import SportRoutes from '../Modules/Sport/Routes/Routes';
import SportRuleRoutes from '../Modules/SportRule/Routes/Routes';
import UserRoutes from '../Modules/User/Routes/Routes';
import WeightRoutes from '../Modules/Weight/Routes/Routes';

const PrivateRoutes = () => {
  const { get } = useApi();
  const { error } = useToast();
  const context = useContext(Context);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getRoles();
  }, []);

  const getRoles = async () => {
    await get(
      '/user/auth',
      (res) => {
        context.user = res.data;
        context.roles = res?.data?.roles;
        setLoading(false);
      },
      (err) => {
        error('دریافت اطلاعات کاربر ناموفق بود.');
        setLoading(false);
      },
    );
  };
  return loading ? (
    <Loading />
  ) : (
    <>
      <DashboardRoutes />
      <AgeRoutes />
      <AgentRoutes />
      <SportRoutes />
      <WeightRoutes />
      <LevelRoutes />
      <GymRoutes />
      <CompetitionRoutes />
      <CompetitionRegisterRoutes />
      <IDCardRoutes />
      <UserRoutes />
      <SportRuleRoutes />
      <RankRoutes />
      <LogRoutes />
      <ErrorRoutes />
    </>
  );
};

export default PrivateRoutes;
